import { UserProfile } from '@clerk/react';
import { Locale } from '../i18n/types';

interface Props {
  locale: Locale;
}

export default function AccountProfile({ locale }: Props) {
  return (
    <div style={{ width: '100%' }} className="d-flex flex-column gap-4">
      <div>
        <h2 className="tab-page-title">Konto</h2>
      </div>

      <UserProfile appearance={{
        variables: {
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          colorBackground: '#1a1d20',
          colorText: '#f8f9fa',
          colorInputBackground: '#212529',
          colorInputText: '#f8f9fa',
          colorPrimary: '#0d6efd',
          colorTextSecondary: '#adb5bd',
          colorDanger: '#dc3545',
          colorSuccess: '#198754',
          borderRadius: '0.375rem',
        },
        elements: {
          card: {
            boxShadow: 'none',
            border: '1px solid #2a2a2a',
            backgroundColor: '#212529',
            width: '100%',
            maxWidth: '100%',
          },
          navbar: {
            borderRight: '1px solid #2a2a2a',
            backgroundColor: '#1a1d20',
          },
          headerTitle: {
            fontSize: '1.25rem',
            fontWeight: '700',
          },
          headerSubtitle: {
            color: '#adb5bd',
          },
          breadcrumbsItem: {
            color: '#adb5bd',
          },
          formButtonPrimary: {
            backgroundColor: '#0d6efd',
            '&:hover': {
              backgroundColor: '#0b5ed7',
            }
          }
        }
      }} />
    </div>
  );
}
